import React from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

/**
 * Shared lightbox overlay shell with close, prev/next, counter, and zoom indicator.
 * Children render inside the central content area.
 */
export const LightboxOverlay = ({
  onClose,
  onPrev,
  onNext,
  currentIndex,
  total,
  zoomLevel,
  isDragging,
  onMouseMove,
  onMouseUp,
  onMouseLeave,
  onOverlayClick,
  testIdPrefix = 'lightbox',
  children,
}) => (
  <div
    className="fixed inset-0 bg-white/95 z-[60] flex items-center justify-center"
    onClick={onOverlayClick}
    onMouseMove={onMouseMove}
    onMouseUp={onMouseUp}
    onMouseLeave={onMouseLeave}
    data-testid={`${testIdPrefix}-overlay`}
  >
    <button
      className="absolute top-6 right-6 text-gray-400 hover:text-gray-700 transition-colors z-20 p-2"
      onClick={(e) => { e.stopPropagation(); onClose(); }}
      data-testid={`${testIdPrefix}-close-btn`}
    >
      <X className="w-6 h-6" />
    </button>
    <button
      onClick={(e) => { e.stopPropagation(); onPrev(); }}
      className="absolute left-4 top-1/2 -translate-y-1/2 p-2 text-gray-300 hover:text-gray-600 transition-all duration-300 z-20"
      data-testid={`${testIdPrefix}-prev-btn`}
    >
      <ChevronLeft className="w-6 h-6" />
    </button>
    <button
      onClick={(e) => { e.stopPropagation(); onNext(); }}
      className="absolute right-4 top-1/2 -translate-y-1/2 p-2 text-gray-300 hover:text-gray-600 transition-all duration-300 z-20"
      data-testid={`${testIdPrefix}-next-btn`}
    >
      <ChevronRight className="w-6 h-6" />
    </button>

    {children}

    <div
      className="absolute bottom-6 left-1/2 -translate-x-1/2 text-gray-400 font-signature text-sm bg-gray-100/80 backdrop-blur-sm px-3 py-1.5 rounded-full"
      data-testid={`${testIdPrefix}-counter`}
    >
      {currentIndex + 1} / {total}
    </div>
    {zoomLevel > 1 && (
      <div className="absolute bottom-6 right-6 text-gray-400 font-signature text-xs bg-gray-100/80 backdrop-blur-sm px-2 py-1 rounded-full">
        {zoomLevel.toFixed(1)}x — drag to pan
      </div>
    )}
  </div>
);
